import { render, staticRenderFns } from "./8.vue?vue&type=template&id=80c0dfc6&scoped=true&"
import script from "./8.vue?vue&type=script&lang=js&"
export * from "./8.vue?vue&type=script&lang=js&"
import style0 from "./8.vue?vue&type=style&index=0&id=80c0dfc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c0dfc6",
  null
  
)

export default component.exports